export const TRACK_MAP_COLORS = [
  '#2563eb',
  '#dc2626',
  '#16a34a',
  '#d97706',
  '#7c3aed',
  '#0891b2',
  '#be185d',
  '#65a30d',
]

export function trackMapColor(index) {
  return TRACK_MAP_COLORS[index % TRACK_MAP_COLORS.length]
}
